// // All public product data comes from the .NET Core API.
// // Set REACT_APP_API_BASE_URL in .env, e.g. http://localhost:5080/api
// const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:5080/api").replace(/\/+$/, "");
// const ASSET_BASE_URL = (process.env.REACT_APP_ASSET_BASE_URL || API_BASE_URL.replace(/\/api\/?$/i, "")).replace(/\/+$/, "");

// const toAssetUrl = (value) => {
//   if (!value) return "";
//   if (typeof value === "object") {
//     value = value.url || value.imageUrl || value.image || value.path || value.filePath || value.videoUrl || "";
//   }
//   if (typeof value !== "string") return "";
//   const path = value.trim();
//   if (!path) return "";
//   if (/^(https?:)?\/\//i.test(path)) {
//     // Replace development host URLs when the site is configured for another API host.
//     if (/^https?:\/\/localhost:5080\//i.test(path)) {
//       return `${ASSET_BASE_URL}/${path.replace(/^https?:\/\/localhost:5080\//i, "")}`;
//     }
//     return path;
//   }
//   if (path.startsWith("data:") || path.startsWith("blob:")) return path;
//   return `${ASSET_BASE_URL}/${path.replace(/^\/+/, "")}`;
// };

// const toNumber = (value) => {
//   if (typeof value === "number") return value;
//   return Number(String(value ?? "").replace(/[₹,\s]/g, "")) || 0;
// };

// const normalizeProduct = (item) => {
//   const gallery = Array.isArray(item.images)
//     ? item.images.map((image) => toAssetUrl(image?.url || image?.Url || image)).filter(Boolean)
//     : [];
//   const primaryImage = toAssetUrl(item.image || item.imageUrl || item.thumbnail);
//   const video = toAssetUrl(item.videoUrl || item.VideoUrl || item.video || item.videoURL);
//   const images = [...new Set([primaryImage, ...gallery].filter(Boolean))];

//   return {
//     ...item,
//     id: item.id ?? item.productId,
//     category: String(item.category || item.categorySlug || item.displayCategory || "other")
//       .toLowerCase().trim().replace(/\s+/g, "-"),
//     displayCategory: item.displayCategory || item.categoryName || item.category || "Other",
//     name: item.name || item.productName || "Unnamed Product",
//     description: item.description || "",
//     longDescription: item.longDescription || "",
//     price: toNumber(item.price ?? item.sellingPrice),
//     oldPrice: toNumber(item.oldPrice ?? item.mrp),
//     image: primaryImage || images[0] || "",
//     images,
//     video,
//     videoUrl: video,
//     isActive: item.isActive !== false,
//     isFeatured: Boolean(item.isFeatured),
//     isNewArrival: Boolean(item.isNewArrival),
//     isNewCollection: Boolean(item.isNewCollection),
//     isRare: Boolean(item.isRare ?? item.rare),
//     isSignature: Boolean(item.isSignature),
//     soldOut: Boolean(item.soldOut),
//   };
// };

// const unwrapProducts = (payload) => {
//   if (Array.isArray(payload)) return payload;
//   if (Array.isArray(payload?.data)) return payload.data;
//   if (Array.isArray(payload?.products)) return payload.products;
//   if (Array.isArray(payload?.items)) return payload.items;
//   return [];
// };

// let productsCache = null;
// let cacheTime = 0;
// const CACHE_MS = 30_000;

// export const loadProducts = async (category) => {
//   if (!productsCache || Date.now() - cacheTime > CACHE_MS) {
//     const response = await fetch(`${API_BASE_URL}/products`, {
//       headers: { Accept: "application/json" },
//     });
//     if (!response.ok) {
//       throw new Error(`Unable to load products (${response.status}). Check the API URL and CORS settings.`);
//     }
//     const payload = await response.json();
//     productsCache = unwrapProducts(payload)
//       .map(normalizeProduct)
//       .filter((product) => product.id != null && product.isActive);
//     cacheTime = Date.now();
//   }

//   if (!category) return [...productsCache];

//   const selected = String(category).toLowerCase().trim().replace(/\s+/g, "-");
//   return productsCache.filter((product) => {
//     const slug = String(product.category || "").toLowerCase().replace(/\s+/g, "-");
//     const display = String(product.displayCategory || "").toLowerCase().replace(/\s+/g, "-");
//     if (selected === "paithani") return slug.includes("paithani") || display.includes("paithani");
//     if (selected === "ilkal") return slug.includes("ilkal") || slug.includes("irkal");
//     return slug === selected || display === selected ||
//       slug.includes(selected) || display.includes(selected);
//   });
// };

// export const loadProductById = async (id) => {
//   const products = await loadProducts();
//   return products.find((product) => String(product.id) === String(id)) || null;
// };

// export const clearProductsCache = () => {
//   productsCache = null;
//   cacheTime = 0;
// };

// const API_BASE_URL = (
//   process.env.REACT_APP_API_BASE_URL || "http://localhost:5080/api"
// ).replace(/\/+$/, "");

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "https://yadnya.azurewebsites.net/api"
).replace(/\/+$/, "");

// const ASSET_BASE_URL = (
//   process.env.REACT_APP_ASSET_BASE_URL || "http://localhost:5080"
// ).replace(/\/+$/, "");

const ASSET_BASE_URL = (
  process.env.REACT_APP_ASSET_BASE_URL || "https://yadnya.azurewebsites.net"
).replace(/\/+$/, "");

const CACHE_DURATION = 30 * 1000;

let productsCache = null;
let productsCacheTime = 0;
let productsRequest = null;

/**
 * Normalize Google Drive image URLs.
 * Files must be accessible to the public or to anyone with the link.
 */
export function normalizeGoogleDriveUrl(url) {
  if (!url || typeof url !== "string") return "";

  const value = url.trim();

  if (!value) return "";

  try {
    const parsedUrl = new URL(value);

    const isGoogleDrive =
      parsedUrl.hostname === "drive.google.com" ||
      parsedUrl.hostname === "www.drive.google.com";

    if (!isGoogleDrive) return value;

    let fileId = parsedUrl.searchParams.get("id");

    if (!fileId) {
      const match = parsedUrl.pathname.match(
        /\/file\/d\/([^/]+)/
      );

      if (match) {
        fileId = match[1];
      }
    }

    if (!fileId) return value;

    return `https://drive.google.com/thumbnail?id=${encodeURIComponent(
      fileId
    )}&sz=w2000`;
  } catch {
    return value;
  }
}

/**
 * Convert image paths into usable URLs.
 *
 * Handles:
 * - Absolute HTTP/HTTPS URLs
 * - Google Drive links
 * - /assets/...
 * - /uploads/...
 * - Relative asset paths
 */
// export function toAssetUrl(path) {
//   if (typeof path !== "string") return "";

//   const value = path.trim();

//   if (!value) return "";

//   // Google Drive or another external absolute URL
//   if (/^https?:\/\//i.test(value)) {
//     return normalizeGoogleDriveUrl(value);
//   }

//   // Protocol-relative URL
//   if (value.startsWith("//")) {
//     return normalizeGoogleDriveUrl(`https:${value}`);
//   }

//   // Remove leading "./" and normalize Windows separators
//   const normalizedPath = value
//     .replace(/\\/g, "/")
//     .replace(/^\.\//, "");

//   // Root-relative paths, such as /assets/Saree/image.webp
//   if (normalizedPath.startsWith("/")) {
//     return `${ASSET_BASE_URL}${normalizedPath}`;
//   }

//   // Relative asset paths, such as assets/Saree/image.webp
//   return `${ASSET_BASE_URL}/${normalizedPath.replace(/^\/+/, "")}`;
// }


export function toAssetUrl(path) {
  if (typeof path !== "string") return "";

  const value = path.trim();
  if (!value) return "";

  // Redirect local public/assets images to the frontend.
  // Google Drive URLs are not changed.
  if (/^https?:\/\//i.test(value)) {
    try {
      const parsedUrl = new URL(value);

      if (
        parsedUrl.pathname.startsWith("/assets/") &&
        !parsedUrl.pathname.startsWith("/assets/videos/")
      ) {
        return (
          parsedUrl.pathname +
          parsedUrl.search +
          parsedUrl.hash
        );
      }
    } catch {
      return value;
    }

    return normalizeGoogleDriveUrl(value);
  }

  // Preserve protocol-relative URLs.
  if (value.startsWith("//")) {
    return normalizeGoogleDriveUrl(`https:${value}`);
  }

  // Normalize relative paths.
  const normalizedPath = value
    .replace(/\\/g, "/")
    .replace(/^\.\//, "");

  // Frontend public/assets paths.
  if (
    normalizedPath.startsWith("/assets/") ||
    normalizedPath.startsWith("assets/")
  ) {
    return normalizedPath.startsWith("/")
      ? normalizedPath
      : `/${normalizedPath}`;
  }

  // Preserve existing handling for other files.
  if (normalizedPath.startsWith("/")) {
    return `${ASSET_BASE_URL}${normalizedPath}`;
  }

  return `${ASSET_BASE_URL}/${normalizedPath.replace(/^\/+/, "")}`;
}

/**
 * Safely parse an image value.
 * The API may return a single string, an array of strings,
 * or objects containing image URLs.
 */
function extractImageUrl(image) {
  if (typeof image === "string") {
    return image.trim();
  }

  if (image && typeof image === "object") {
    return (
      image.url ||
      image.imageUrl ||
      image.image ||
      image.path ||
      image.src ||
      ""
    );
  }

  return "";
}

/**
 * Convert the API image collection into a normalized,
 * de-duplicated array of URLs.
 */
export function normalizeProductImages(product) {
  if (!product || typeof product !== "object") {
    return [];
  }

  const candidates = [
    product.image,
    product.mainImage,
    product.thumbnail,
    product.images,
    product.productImages,
  ];

  const collectedImages = [];

  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      collectedImages.push(...candidate);
    } else if (candidate) {
      collectedImages.push(candidate);
    }
  }

  const normalizedImages = collectedImages
    .map(extractImageUrl)
    .filter(Boolean)
    .map(toAssetUrl)
    .filter(Boolean);

  // Preserve order while removing duplicates.
  return [...new Set(normalizedImages)];
}

/**
 * Normalize a product received from the API.
 */
export function normalizeProduct(product) {
  if (!product || typeof product !== "object") {
    return null;
  }

  const images = normalizeProductImages(product);

  const rawVideo =
    product.videoUrl ||
    product.video ||
    product.productVideo ||
    "";

  const videoUrl = toAssetUrl(rawVideo);

  return {
    ...product,
    id: product.id ?? product.productId ?? product.Id,
    name: product.name || product.productName || "Handloom Saree",
    category: product.category || "",
    displayCategory:
      product.displayCategory || product.category || "",
    image: images[0] || "",
    images,
    videoUrl,
    video: videoUrl,
  };
}

/**
 * Fetch products from the .NET API.
 * A short cache prevents repeated requests when components
 * load product data close together.
 */
export async function loadProducts({ forceRefresh = false } = {}) {
  const cacheIsValid =
    productsCache &&
    Date.now() - productsCacheTime < CACHE_DURATION;

  if (!forceRefresh && cacheIsValid) {
    return productsCache;
  }

  if (!forceRefresh && productsRequest) {
    return productsRequest;
  }

  productsRequest = (async () => {
    const response = await fetch(`${API_BASE_URL}/products`, {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Failed to load products: HTTP ${response.status}`
      );
    }

    const data = await response.json();

    // Support APIs returning either an array or a wrapper object.
    const productList = Array.isArray(data)
      ? data
      : Array.isArray(data.products)
        ? data.products
        : Array.isArray(data.items)
          ? data.items
          : Array.isArray(data.data)
            ? data.data
            : [];

    productsCache = productList
      .map(normalizeProduct)
      .filter(Boolean);

    productsCacheTime = Date.now();

    return productsCache;
  })();

  try {
    return await productsRequest;
  } finally {
    productsRequest = null;
  }
}

/**
 * Find one product by ID.
 */
export async function loadProductById(id, options = {}) {
  if (id === undefined || id === null || id === "") {
    throw new Error("A product ID is required.");
  }

  const products = await loadProducts(options);

  const product = products.find(
    (item) => String(item.id) === String(id)
  );

  if (!product) {
    throw new Error(`Product with ID "${id}" was not found.`);
  }

  return product;
}

/**
 * Clear cached product data after adding, editing, or deleting
 * products in the admin dashboard.
 */
export function clearProductsCache() {
  productsCache = null;
  productsCacheTime = 0;
  productsRequest = null;
}

export default loadProductById;
